import { isBrandRefreshEnabled } from '../../shared/utilities/brandRefresh';

export const isOrderReviewBrandRefresh = () => isBrandRefreshEnabled();

export const getOrderReviewPartProps = part =>
  isBrandRefreshEnabled() ? { 'data-part': part } : {};

export const getOrderReviewItemTitle = (amount, itemTitle) =>
  isBrandRefreshEnabled() ? `${amount} · ${itemTitle}` : itemTitle;

export const getOrderReviewLineTotal = (unitPrice, quantity) => {
  if (!isBrandRefreshEnabled()) {
    return unitPrice;
  }

  const unit = parseFloat(unitPrice);
  const qty = quantity || 1;
  if (Number.isNaN(unit)) {
    return unitPrice;
  }

  return (unit * qty).toFixed(2);
};

export const getModifyOrderLabel = () =>
  isBrandRefreshEnabled() ? 'Modify order' : 'Modify Order';

const titleAlreadyHasQuantity = title => /^\s*\d+(\.\d+)?\s+/.test(title || '');

export const getBoxOptionQuantity = (boxProduct, productOptions) => {
  if (!isBrandRefreshEnabled() || !boxProduct || titleAlreadyHasQuantity(boxProduct.title)) {
    return null;
  }

  if (boxProduct.quantity != null && boxProduct.quantity !== '') {
    return boxProduct.quantity;
  }

  if (!productOptions || !productOptions.length) {
    return null;
  }

  const match = productOptions.find(option => {
    if (option.title === boxProduct.title) {
      return true;
    }

    const optionId = option.options && option.options.id;
    return optionId != null && String(optionId) === String(boxProduct.id);
  });

  return match && match.quantity != null ? match.quantity : null;
};
